/**
 * native-payments.js — monetizzazione dentro l'app Capacitor (store IAP).
 *
 * Caricato dalla shell PHP SUBITO DOPO js/web-payments.js e attivo SOLO nel
 * runtime nativo: l'app carica la stessa shell web (TY_WEB = true), quindi
 * senza questo file il checkout finirebbe su Stripe — che le policy di App
 * Store e Play Store non permettono. Sul web esce subito: zero impatto.
 *
 * Resta la STESSA pagina checkout del web (.pageMob-checkout, card renderizzate
 * da tyWebRenderPricing di web-payments.js), con tre differenze:
 *  - si vedono solo i piani che hanno un prodotto corrispondente DISPONIBILE
 *    sullo store (store_payments.android|ios + getAllProductInfo);
 *  - il prezzo mostrato e' quello dello store (gia' localizzato: e' quello che
 *    l'utente paga davvero);
 *  - il tap apre l'acquisto in-app (inAppPurchases.purchase → POST
 *    /payments/app), come faceva la vecchia app nativa.
 *
 * Anche la voce Pagamenti del profilo porta qui: sul nativo non esistono ne'
 * il Billing Portal Stripe ne' lo storico pagamenti web.
 */
(function () {

    // runtime nativo: html.ty-native e' l'hook impostato dalla shell
    // (index.html), con fallback al check diretto sul bridge Capacitor
    function tyNativeIsRuntime() {
        try {
            if (document.documentElement.classList.contains('ty-native')) {
                return true;
            }
            return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
        } catch (err) {
            return false;
        }
    }

    if (!tyNativeIsRuntime()) { return; }

    // id piano (quello su cui clicca l'utente) -> id prodotto dello store,
    // popolata a ogni render della lista prezzi
    var storeProductByPlan = {};

    // piattaforma dello store: Capacitor la sa subito, userDevice arriva solo
    // dopo il deviceready di app.js (device.platform)
    function tyNativeStorePlatform() {
        try {
            if (window.Capacitor && typeof window.Capacitor.getPlatform === 'function') {
                var platform = window.Capacitor.getPlatform();
                if (platform === 'android' || platform === 'ios') { return platform; }
            }
        } catch (err) {}
        if (typeof userDevice === 'string' && (userDevice === 'android' || userDevice === 'ios')) {
            return userDevice;
        }
        try {
            if (typeof cordova !== 'undefined' && cordova.platformId) { return cordova.platformId; }
        } catch (err) {}
        return null;
    }

    function tyNativeIsLogged() {
        return typeof userData !== 'undefined' && !!userData && userData.status == 'success';
    }

    // niente prodotti acquistabili in app: come nella vecchia app si rimanda
    // al sito, mai a un checkout esterno (le policy degli store lo vietano)
    function tyNativeStoreUnavailableHtml() {
        var domain = (typeof companyDomain !== 'undefined' && companyDomain) ? companyDomain : '';
        return `<div class="premiumContents"><p class="white text-center" style="margin-top:10vh;">${translate('EXPLORE_CONTENT_ACCESS_OPTIONS_ON')} ${domain}</p></div>`;
    }

    /* ------------------------------------------------------------------ *
     * Override: pagina checkout
     * ------------------------------------------------------------------ */

    // Dentro l'app il checkout e' una pagina come le altre e ci si arriva
    // sempre da qualcos'altro (profilo, collection, paywall): nell'header ci
    // vuole la freccia indietro, come nella ricerca per categoria
    // (clickedBrowseAll in appHeader.js). Sul web l'header e' quello del sito
    // e resta com'e'.
    var tyWebOpenCheckoutPage = openModalPaymentPreview;
    openModalPaymentPreview = function (idc) {
        var result = tyWebOpenCheckoutPage(idc);
        $('#mobile-logo-native-label').html(
            `<span class="header-back-liquid" onclick="checkGeneralCurrentState();"><i class="ri-arrow-left-line"></i></span> ${translate('SUBSCRIPTION')}`
        );
        return result;
    };

    /* ------------------------------------------------------------------ *
     * Override: lista prezzi della pagina checkout
     * ------------------------------------------------------------------ */

    getListPricing = function (el, url, options) {
        options = options || {};
        $(el).html(tyWebSpinnerHtml());
        $.ajax({
            type: 'GET',
            async: true,
            url: url,
            success: function (json) {
                var plans = tyWebParseJson(json);
                if (!Array.isArray(plans)) { plans = []; }
                tyNativeRenderStorePlans(el, plans, options);
            },
            error: function () {
                $(el).html('');
            }
        });
    };

    // id prodotto store del piano per la piattaforma corrente
    function tyNativeProductIdOf(plan, platform) {
        return (plan && plan.store_payments && platform) ? plan.store_payments[platform] : null;
    }

    // incrocia i piani dell'API con i prodotti realmente disponibili sullo
    // store: quelli senza prodotto (o non trovati dallo store) non vengono
    // mostrati, non essendoci modo di acquistarli dentro l'app
    function tyNativeRenderStorePlans(el, plans, options) {
        var platform = tyNativeStorePlatform();
        var productIds = [];
        var seenProduct = {};

        for (var i = 0; i < plans.length; i++) {
            var wantedId = tyNativeProductIdOf(plans[i], platform);
            if (!wantedId || seenProduct[wantedId]) { continue; }
            seenProduct[wantedId] = true;
            productIds.push(wantedId);
        }

        if (!productIds.length || !window.inAppPurchases) {
            $(el).html(tyNativeStoreUnavailableHtml());
            return;
        }

        inAppPurchases.getAllProductInfo(productIds).then(function (products) {
            var storeByProduct = {};
            for (var i = 0; i < (products || []).length; i++) {
                if (products[i] && products[i].productId) {
                    storeByProduct[products[i].productId] = products[i];
                }
            }

            // si cicla sui piani dell'API, non sui prodotti dello store:
            // l'ordine resta quello deciso in dashboard (lo store restituisce
            // i prodotti nell'ordine che vuole), qui si filtra soltanto
            var available = [];
            for (var z = 0; z < plans.length; z++) {
                var plan = plans[z];
                var productId = tyNativeProductIdOf(plan, platform);
                var product = productId ? storeByProduct[productId] : null;
                if (!product) { continue; }

                // introductoryOriginalPrice = prezzo pieno quando c'e'
                // un'offerta introduttiva: mostrare lo sconto come prezzo
                // del piano sarebbe fuorviante (lo store lo espone
                // comunque al momento dell'acquisto)
                plan.price_final = product.introductoryOriginalPrice || product.price || plan.price_final;
                plan.currencySymbol = ''; // il prezzo dello store ha gia' la valuta
                storeProductByPlan[String(plan.id_parent || plan.id)] = productId;
                available.push(plan);
            }

            if (!available.length) {
                $(el).html(tyNativeStoreUnavailableHtml());
                return;
            }

            tyWebRenderPricing(el, available, options);
            tyNativeAppendManageSubscriptions(el, platform);
        }).catch(function (err) {
            try { console.log('IAP getAllProductInfo', JSON.stringify(err)); } catch (e) {}
            $(el).html(tyNativeStoreUnavailableHtml());
        });
    }

    // chi ha gia' un abbonamento sullo store deve poterlo gestire/disdire:
    // gli store richiedono il rimando alla loro gestione abbonamenti
    function tyNativeAppendManageSubscriptions(el, platform) {
        if (!tyNativeIsLogged() || !userData.has_mobile_payments) { return; }
        if (platform !== 'android' && platform !== 'ios') { return; }
        $(el).find('.premiumContents').append(`
            <a href="#" onclick="tyNativeOpenStoreSubscriptions(); return false;" class="white ty-native-store-manage">
                ${translate('MANAGE_THIS')} ${translate('SUBSCRIPTIONS')} <i class="ri-arrow-right-line"></i>
            </a>
        `);
    }

    // gestione abbonamenti sullo store (browser tab: fuori dalla webview)
    window.tyNativeOpenStoreSubscriptions = function () {
        var platform = tyNativeStorePlatform();
        var url;
        if (platform === 'ios') {
            url = 'itms-apps://apps.apple.com/account/subscriptions';
        } else if (platform === 'android') {
            url = 'https://play.google.com/store/account/subscriptions';
            if (typeof PLAY_STORE_ID !== 'undefined' && PLAY_STORE_ID) {
                url += '?package=' + PLAY_STORE_ID;
            }
        } else {
            return false;
        }
        try {
            cordova.plugins.browsertabs.openUrlInBrowser(url, onSuccessBrowserTabOpened, onErrorBrowserTabOpened);
        } catch (err) {
            window.open(url, '_system');
        }
        return false;
    };

    /* ------------------------------------------------------------------ *
     * Override: acquisto (store, mai Stripe)
     * ------------------------------------------------------------------ */

    // tap su una card della pagina checkout: arriva l'id del PIANO, che va
    // tradotto nell'id prodotto dello store risolto durante il render
    tyWebStartCheckout = function (planId) {
        if (!planId) { return false; }
        if (!tyNativeIsLogged()) {
            openModalLogin(true);
            return false;
        }
        var productId = storeProductByPlan[String(planId)];
        if (!productId) {
            // piano mai passato dal render (CTA diretta): invece di un vicolo
            // cieco si apre il checkout, che risolve i prodotti dello store
            openModalPaymentPreview(planId);
            return false;
        }
        return startPayInApp(productId);
    };

    // semantica nativa storica: qui arriva direttamente l'id prodotto store
    linkPaymentIapPreview = function (productId) {
        if (!tyNativeIsLogged()) {
            openModalLogin(true);
            return false;
        }
        return startPayInApp(productId);
    };

    // Un acquisto per volta: due purchase() ravvicinate aprono due schede
    // d'acquisto sovrapposte sullo store. Il lock sta sul PLUGIN, non sul
    // chiamante, cosi' copre ogni percorso (tap sulla card, tap sulla CTA,
    // ghost click touch->click, codice legacy) senza finestre temporali: si
    // libera appena la promise dello store si chiude — acquisto riuscito,
    // annullato o fallito che sia.
    var purchaseInFlight = false;
    var purchaseWatchdog = null;

    function tyNativeSerializePurchases() {
        // il plugin arriva col deviceready: si patcha alla prima chiamata
        if (!window.inAppPurchases || inAppPurchases.tyNativeSerialized) { return; }

        var storePurchase = inAppPurchases.purchase;
        inAppPurchases.purchase = function () {
            if (purchaseInFlight) {
                // 'pending' e' il caso che i chiamanti gia' gestiscono
                // uscendo in silenzio (vedi startPayInApp in app.js)
                return Promise.resolve({ pending: true });
            }

            purchaseInFlight = true;
            // se la promise non si chiudesse mai (plugin bloccato) l'utente
            // resterebbe senza poter comprare: rilascio di sicurezza
            clearTimeout(purchaseWatchdog);
            purchaseWatchdog = setTimeout(function () { purchaseInFlight = false; }, 90000);

            function release() {
                purchaseInFlight = false;
                clearTimeout(purchaseWatchdog);
            }

            var result;
            try {
                result = storePurchase.apply(inAppPurchases, arguments);
            } catch (err) {
                release();
                throw err;
            }

            try { result.then(release, release); } catch (err) { release(); }
            return result;
        };

        inAppPurchases.tyNativeSerialized = true;
    }

    // rimette l'acquisto in-app di app.js (web-payments.js l'aveva sostituito
    // col checkout Stripe); type/params del web qui non servono: sullo store
    // non ci sono coupon ne' gift card
    startPayInApp = function (productId) {
        if (!productId) { return false; }
        if (typeof tyNativeStartPayInApp !== 'function' || !window.inAppPurchases) {
            open_notifications_toast(translate('ERROR_OCCURRED'), 'red');
            return false;
        }
        tyNativeSerializePurchases();
        return tyNativeStartPayInApp(productId);
    };

    /* ------------------------------------------------------------------ *
     * Override: voce Pagamenti del profilo
     * ------------------------------------------------------------------ */

    // sul nativo non esistono ne' la pagina pagamenti web ne' il Billing
    // Portal Stripe: Pagamenti apre sempre il checkout con i piani dello store
    openIapSettings = function () {
        openModalPaymentPreview();
    };

    tyWebOpenPayments = function () {
        openModalPaymentPreview();
    };

})();
